/**
 * @generated SignedSource<<6b0aee2815fcb7a4368e7af3412f7772>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatThreadEditDialog_SearchQuery$variables = {
  hasThread: boolean;
  search?: string | null | undefined;
  threadId?: string | null | undefined;
};
export type ChatThreadEditDialog_SearchQuery$data = {
  readonly currentUser?: {
    readonly contacts: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"Contact_Contact">;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly thread?: {
    readonly inviteableAndCurrentUsers?: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"Contact_Contact">;
      } | null | undefined> | null | undefined;
    };
  } | null | undefined;
};
export type ChatThreadEditDialog_SearchQuery = {
  response: ChatThreadEditDialog_SearchQuery$data;
  variables: ChatThreadEditDialog_SearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasThread"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "threadId"
},
v3 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "kind": "ObjectValue",
    "name": "filters"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Contact_Contact"
      }
    ],
    "storageKey": null
  }
],
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "threadId"
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatThread",
  "kind": "LinkedField",
  "name": "directChatThread",
  "plural": false,
  "selections": [
    (v4/*: any*/)
  ],
  "storageKey": null
},
v10 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v4/*: any*/),
      {
        "kind": "InlineFragment",
        "selections": [
          (v7/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ChatContact",
                "kind": "LinkedField",
                "name": "chatContact",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "description",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "self",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lastSeenAt",
                "storageKey": null
              }
            ],
            "type": "User",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v8/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "avatarUrl",
                "storageKey": null
              }
            ],
            "type": "ChatBot",
            "abstractKey": null
          }
        ],
        "type": "Recipient",
        "abstractKey": "__isRecipient"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChatThreadEditDialog_SearchQuery",
    "selections": [
      {
        "condition": "hasThread",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "contacts",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasThread",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "thread",
            "args": (v6/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "optionalNode",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v3/*: any*/),
                    "concreteType": "UserConnection",
                    "kind": "LinkedField",
                    "name": "inviteableAndCurrentUsers",
                    "plural": false,
                    "selections": (v5/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "ChatThread",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ChatThreadEditDialog_SearchQuery",
    "selections": [
      {
        "condition": "hasThread",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v3/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "contacts",
                "plural": false,
                "selections": (v10/*: any*/),
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ]
      },
      {
        "condition": "hasThread",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "thread",
            "args": (v6/*: any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "optionalNode",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              (v4/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": (v3/*: any*/),
                    "concreteType": "UserConnection",
                    "kind": "LinkedField",
                    "name": "inviteableAndCurrentUsers",
                    "plural": false,
                    "selections": (v10/*: any*/),
                    "storageKey": null
                  }
                ],
                "type": "ChatThread",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "e0b19f8a0a11c65e5c40cc0ee83e1ba2",
    "id": null,
    "metadata": {},
    "name": "ChatThreadEditDialog_SearchQuery",
    "operationKind": "query",
    "text": "query ChatThreadEditDialog_SearchQuery(\n  $search: String\n  $threadId: ID\n  $hasThread: Boolean!\n) {\n  currentUser @skip(if: $hasThread) {\n    contacts(first: 3, filters: {search: $search}) {\n      nodes {\n        id\n        ...Contact_Contact\n      }\n    }\n    id\n  }\n  thread: optionalNode(id: $threadId) @include(if: $hasThread) {\n    __typename\n    ... on ChatThread {\n      inviteableAndCurrentUsers(first: 3, filters: {search: $search}) {\n        nodes {\n          id\n          ...Contact_Contact\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment Contact_Contact on Recipient {\n  __isRecipient: __typename\n  ... on User {\n    id\n    name\n    directChatThread {\n      id\n    }\n  }\n  ... on ChatBot {\n    id\n    name\n    directChatThread {\n      id\n    }\n  }\n  ...RecipientAvatar_Recipient\n  ...chat_useContactDescription\n}\n\nfragment RecipientAvatar_Recipient on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    ...UserAvatarContainer_User\n  }\n  ... on ChatBot {\n    name\n    avatarUrl\n  }\n}\n\nfragment UserAvatarContainer_User on User {\n  id\n}\n\nfragment chat_useContactDescription on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    chatContact {\n      description\n      id\n    }\n  }\n  ...chat_useOnlineStatus\n}\n\nfragment chat_useOnlineStatus on Recipient {\n  __isRecipient: __typename\n  __typename\n  ... on User {\n    self\n    lastSeenAt\n  }\n  ... on ChatBot {\n    __typename\n  }\n}\n"
  }
};
})();

(node as any).hash = "fc9bf22bf730dc82d688c22c74ba260f";

export default node;
